import { SpriteMapping } from '~/models/common/types'

export const vehicleSpriteMappings: Record<
  string,
  SpriteMapping
> = Object.freeze({
  van: {
    positionX: -1614,
    positionY: -19,
    width: 107,
    height: 64,
    backgroundWidth: 66
  },
  forklift: {
    positionX: -1328,
    positionY: -19,
    width: 103,
    height: 64,
    backgroundWidth: 60
  },
  clark: {
    positionX: -1328,
    positionY: -19,
    width: 103,
    height: 64,
    backgroundWidth: 60
  },
  watersport: {
    positionX: -502,
    positionY: -19,
    width: 94,
    height: 64,
    backgroundWidth: 50
  },
  xyma: {
    positionX: -1045,
    positionY: -19,
    width: 101,
    height: 64,
    backgroundWidth: 56
  },
  radiocontrol: {
    positionX: -636,
    positionY: -19,
    width: 95,
    height: 64,
    backgroundWidth: 48
  },
  truck: {
    positionX: -384,
    positionY: -19,
    width: 98,
    height: 64,
    backgroundWidth: 59
  },
  truck_professional: {
    positionX: -384,
    positionY: -19,
    width: 98,
    height: 64,
    backgroundWidth: 59
  },
  tractor: {
    positionX: -1186,
    positionY: -19,
    width: 102,
    height: 64,
    backgroundWidth: 58
  },
  bicycle: {
    positionX: -2084,
    positionY: -19,
    width: 111,
    height: 64,
    backgroundWidth: 58
  },
  builder: {
    positionX: -2225,
    positionY: -19,
    width: 116,
    height: 64,
    backgroundWidth: 76
  },
  snowsport: {
    positionX: -1761,
    positionY: -19,
    width: 114,
    height: 64,
    backgroundWidth: 67
  },
  semitruck: {
    positionX: -111,
    positionY: -19,
    width: 98,
    height: 64,
    backgroundWidth: 58
  },
  gokart: {
    positionX: -771,
    positionY: -19,
    width: 96,
    height: 64,
    backgroundWidth: 58
  },
  bike: {
    positionX: -1471,
    positionY: -19,
    width: 103,
    height: 64,
    backgroundWidth: 64
  },
  motorcycle: {
    positionX: -1471,
    positionY: -19,
    width: 103,
    height: 64,
    backgroundWidth: 64
  },
  taxi: {
    positionX: -3207,
    positionY: -19,
    width: 146,
    height: 64,
    backgroundWidth: 77
  },
  motorhome: {
    positionX: -2539,
    positionY: -19,
    width: 117,
    height: 64,
    backgroundWidth: 72
  },
  caravan: {
    positionX: -3036,
    positionY: -19,
    width: 120,
    height: 64,
    backgroundWidth: 78
  },
  trailer: {
    positionX: -3586,
    positionY: -19,
    width: 115,
    height: 64,
    backgroundWidth: 70
  },
  parts: {
    positionX: -2868,
    positionY: -19,
    width: 124,
    height: 64,
    backgroundWidth: 81
  },
  boat: {
    positionX: -237,
    positionY: -19,
    width: 130,
    height: 64,
    backgroundWidth: 80
  },
  car: {
    positionX: -3767,
    positionY: -19,
    width: 127,
    height: 64,
    backgroundWidth: 80
  },
  semitrailer: {
    positionX: -3398,
    positionY: -19,
    width: 128,
    height: 64,
    backgroundWidth: 80
  },
  bus: {
    positionX: -3973,
    positionY: -19,
    width: 127,
    height: 64,
    backgroundWidth: 80
  },
  airsport: {
    positionX: -2381,
    positionY: -19,
    width: 119,
    height: 64,
    backgroundWidth: 75
  },
  tools_equipment_garages: {
    positionX: -4149,
    positionY: -16,
    width: 102,
    height: 64,
    backgroundWidth: 60
  },
  construction_machinery: {
    positionX: -4296,
    positionY: -19,
    width: 130,
    height: 64,
    backgroundWidth: 81
  }
})
